export interface IPaymentCurrencyBreakDown {
  amount: number
  currencyId: number;
  currencySymbol: string;
  currencyCode: string;
}